export const STAGE_THEMES = {
  blue: {
    name: 'Morning Blue',
    primary: '#3B82F6',
    ring: '#93C5FD',
    glow: 'rgba(59, 130, 246, 0.35)',
    deep: '#081120',
  },
  red: {
    name: 'Noon Red',
    primary: '#EF4444',
    ring: '#FCA5A5',
    glow: 'rgba(239, 68, 68, 0.32)',
    deep: '#1C0909',
  },
  green: {
    name: 'Evening Green',
    primary: '#22C55E',
    ring: '#86EFAC',
    glow: 'rgba(34, 197, 94, 0.30)',
    deep: '#06170C',
  },
  purple: {
    name: 'Night Purple',
    primary: '#A855F7',
    ring: '#D8B4FE',
    glow: 'rgba(168, 85, 247, 0.35)',
    deep: '#130A22',
  },
};

export const GOLD = '#D4AF37';
export const GOLD_LIGHT = '#F9DF9F';
